import { ChevronRight, Home } from "lucide-react";
import { cn } from "./ui/utils";

interface BreadcrumbProps {
  items: { label: string; href?: string }[];
  className?: string;
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <nav className={cn("flex items-center space-x-2 text-sm text-muted-foreground", className)}>
      <Home className="h-4 w-4" />
      {items.map((item, index) => (
        <div key={index} className="flex items-center space-x-2">
          <ChevronRight className="h-4 w-4" />
          <span
            className={cn(
              index === items.length - 1
                ? "text-foreground font-medium"
                : "hover:text-foreground cursor-pointer"
            )}
          >
            {item.label}
          </span>
        </div>
      ))}
    </nav>
  );
}
